import {useRef, useState} from "react";
import {imageUrl} from "utils/url";

const VideoModal = () => {
  const video = useRef(null);
  const [isActive, setIsActive] = useState(false);

  const showVideo = () => {
    setIsActive(true);
    video.current.play();
  };

  const closeVideo = () => {
    setIsActive(false);
    video.current.pause();
    video.current.currentTime = 0;
  };

  return (
    <>
      <div className="g-animeBanner">
        <img src={imageUrl('anime/banner_anime_cht.png')} onClick={showVideo} alt="想輕鬆入手日本限定商品？讓Buyee幫你！"/>
      </div>

      <div className={"modal " + (isActive ? "" : "is-hidden")}>
        <div className="g-modalBanner__outer g-modalBanner__outer--video">
          <video ref={video} controls muted>
            <source src={imageUrl('anime/buyee_anime.mp4')} type="video/mp4"/>
          </video>
          <button type="button" onClick={closeVideo} className="g-button g-modalBanner__closeButton blue">
            <i className="g-feather g-feather-x"></i>
          </button>
        </div>
      </div>
    </>
  );
};

export default VideoModal;
